import { Component, OnInit } from '@angular/core';
import { FormsService } from 'src/app/services/forms/forms.service';
import { MasterListModel } from 'src/app/services/forms/master-list-model';
import { MessageService } from 'src/app/services/message.service';
import { SubmenuService } from '../../submenu/submenu.service';

@Component({
  selector: 'app-master-list',
  templateUrl: './master-list.component.html',
  styleUrls: ['./master-list.component.less']
})
export class MasterListComponent implements OnInit {

  page:number = 1;
  componentData: MasterListModel | undefined;
  
  constructor(public formsService: FormsService, public messageService:MessageService, public submenuService:SubmenuService) 
  { 
    
  }

  ngOnInit(): void {
    
    this.messageService.showLoading();
    this.formsService.loadMastersPage(this.page).subscribe((data:MasterListModel) => {
        this.componentData = data;
        this.messageService.hideLoading();
    },    
    err => {
      this.messageService.hideLoading();
      this.messageService.showMessage(err.message, "error");
      console.log(err);
    });
  }

  ngAfterViewChecked(){
    this.submenuService.showRecordList("/layouts");    
  }

}
